import { Component, Input, OnInit } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { DatetimeService, FilesService } from 'src/app/services';
import { ApiSpecificationsDataDownloadService } from 'src/app/services/api-specifications-data-download.service';
import { ApispecificationService } from 'src/app/services/api-specifications.service';

@Component({
  selector: 'app-products-download-specifications-history',
  templateUrl: './products-download-specifications-history.component.html',
  styleUrls: ['./products-download-specifications-history.component.css']
})
export class ProductsDownloadSpecificationsHistoryComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  loading: boolean;
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  currentOrgId: string;
  productsIds: string[] = [];
  specificationsHistory: any[] = [];

  @Input() set objectData(value) {

    if (value != null) {

      this.currentOrgId = value.org_id;
      this.productsIds = value.product_ids;

      this.getList();
    }
  }



  constructor(
    public ngProgress: NgProgress,
    private fileService: FilesService,
    private downloadSpecificationsService: ApiSpecificationsDataDownloadService,
    private datetimeService: DatetimeService,
    private apiSpecificationsService: ApispecificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.subscriptions.add(
      this.downloadSpecificationsService.listenerSpecificationsDataForReload().subscribe(val => {

        if (val) {

          this.getList();
        }

      })
    );
  }


  /**
   * 
   */
  getList(): void {

    // this.progressRef.start();
    this.loading = true;
    this.specificationsHistory = [];

    this.setListParams();

    this.apiSpecificationsService.getSpecificationsReference(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getSpecHistoryList: ', response);

      if (response.result != null) {

        this.specificationsHistory = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        ref_type: "spec_history"
      },
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
 * 
 * @param item 
 */
  onDownload(item: any) {

    // this.fileService.downloadWithSettings('downloadSpec', item);

    let data = {
      spec_id: item.id,
      prod_id: this.productsIds
    }

    this.fileService.downloadWithSettings('downloadSpec', data, this.specificationsHistory.find(val => val.id == item.id).name);
    setTimeout(() => this.downloadSpecificationsService.reloadList(this.currentOrgId), 200);

  }

  /**
   * 
   * @param item 
   */
  onEditDownload(item: any) {

    this.downloadSpecificationsService.setSpecificationsData(item);
    this.downloadSpecificationsService.switchTab(true);

  }

}
